import axios, { AxiosError, AxiosInstance } from 'axios';

import { AppConfig } from './AppConfig';
import { useAuthContext } from '../auth/hooks';

export const Endpoints = {
  accommodations: '/accommodations',
  banBook: '/ban-book',
  banBookReport: '/reports/ban-book',
  banBookReportSummary: '/reports/ban-book/summary',
  cancelSubscription: '/subscription',
  challengeRate: '/ban-book/challenge-rate',
  checkSubscriptionStatus: '/subscription_status',
  createSubscription: '/create-subscription',
  createCustomer: '/create-customer',
  createUser: '/create-user',
  fetchSubscription: '/subscription',
  health: '/health',
  homework: '/homework',
  homeworkTrial: (homeworkId: string) => `/homework/${homeworkId}/trials`,
  homeworkTask: (homeworkId: string) => `homework/${homeworkId}/task`,
  obessions: '/obsessions',
  ocdTypes: '/ocd-types',
  paymentMethods: '/payment-methods',
  prices: '/prices',
  removePaymentMethod: '/payment-method/',
  resitsRate: '/ban-book/resist-rate',
  stripePromise: '/stripe-public-key',
  surverys: '/surveys',
  surveyAverage: '/survey-average',
  surveyLast: '/last-survey',
  claimPatientInvite: '/patients/claimInvite',
  getPatientProviderInfoByInvite: '/patients/providerInfo/byInvite',
  getPatientProviderInfoByUser: '/patients/providerInfo',
  getUser: '/users/me'
};

let apiInstance: AxiosInstance;
export const OcdFeatApi = (token: any) => {
  if (!apiInstance) {
    apiInstance = axios.create({
      baseURL: AppConfig.apiBaseUrl,
      headers: {
        'Client-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone
      }
      // timeout: 4000
    });

    // Add a response interceptor
    apiInstance.interceptors.response.use(
      (response) => response, // Pass through successful responses
      (error: AxiosError) => {
        if (error.response && error.response.status === 401) {
          window.location.href = `auth/logout?returnTo=${window.location.origin}`;
        }
        return Promise.reject(error); // Let the calling component handle other errors
      }
    );
  }

  // Update Authorization header with the latest token
  apiInstance.defaults.headers.common.Authorization = `Bearer ${token}`;

  return apiInstance;
};

export const useApiRepo = () => {
  const {getAccessToken} = useAuthContext();
  const getObjectsFromAPI = async () => {
    const token = await getAccessToken();
    return OcdFeatApi(token);
  };
  return { getObjectsFromAPI };
};
